import * as React from 'react';
import { initLazySizes } from './utils';
import { FullscreenGalleryContainer, CarouselSliderContainer } from './containers';
import { EMediaType, IGallerySlide } from '../../types/project';
import { TourModalContainerMobile } from '../TourModalContainer';

export const GalleryContainerMobile = () => {
  const sliderRef = React.useRef<HTMLUListElement | null>(null);
  const [startWithSlide, setStartWithSlide] = React.useState<number | null>(null);
  const [tourOpened, toggleTourModal] = React.useState(false);

  const handleSlideClick = React.useCallback(
    (slide: IGallerySlide, index: number) => {
      if (startWithSlide === null) {
        // Не полноэкранный режим
        if (slide.type === EMediaType.Tour) {
          toggleTourModal(true);
        } else {
          setStartWithSlide(index);
        }
      } else {
        // Полноэкранный режим
        if (slide.type === EMediaType.Tour) {
          toggleTourModal(true);
        }
      }
    },
    [startWithSlide],
  );

  const closeGallery = React.useCallback(() => {
    setStartWithSlide(null);
  }, []);

  React.useEffect(initLazySizes, []);

  return (
    <>
      <CarouselSliderContainer sliderRef={sliderRef} onSlideClick={handleSlideClick} />
      <FullscreenGalleryContainer
        sliderRef={sliderRef}
        startSlide={startWithSlide}
        closeModal={closeGallery}
        onSlideClick={handleSlideClick}
      />
      {tourOpened && <TourModalContainerMobile onClose={() => toggleTourModal(false)} />}
    </>
  );
};
